<div class="menu-grid f-main-center f-cross-center f-wrap cgap-10 rgap-10 p-10" [@listAnim]="total()">
    @for(brand of brands(); track brand._id){
        <menu-card [brand]="brand"></menu-card>
    }
</div>
@if(autoload() && !loading() && brands().length){
    <div class="tester" inViewport (inViewportAction)="viewportTrigger($event)" [inViewportOptions]="{ threshold: [0] }"></div>
}

@if(!is_final()){
    <div class="svg-loader">
        <object data="old/cloudigo_loader.svg" type="image/svg+xml"></object>
    </div>
} @else if(!brands().length){
    <p>No Menus found</p>

}